import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { FormattedMessage } from 'react-intl'
import { Field } from 'redux-form'
import styles from './_cvcField.css'
import fieldProps from 'components/forms/fieldProps'
import classnames from 'classnames'
import CvcTooltip from './CVCTooltip'
import FieldLabel from 'components/forms/FieldLabel'
import FieldError from 'components/forms/FieldError'

export class CVCField extends Component {

  state = {
    showTooltip: false,
  }

  handleToggleCvc = () => {
    this.setState({ showTooltip: !this.state.showTooltip })
  }

  handleHideCvcTooltip = () => {
    this.setState({ showTooltip: false })
  }

  render () {
    const {
      input,
      name,
      type,
      placeholder,
      disabled,
      meta: {
        touched,
        error,
      },
    } = this.props

    const showError = Boolean(touched && error)

    return (
      <label
        htmlFor={name}
        className={classnames(styles.container, {
          [styles.disabled]: disabled,
        })}
      >

        {this.state.showTooltip ?
          <CvcTooltip
            onClickOutside={this.handleHideCvcTooltip}
            onClick={this.handleHideCvcTooltip}
          />
        : null}

        <FieldLabel required disabled={disabled} labelComponent={(
          <FormattedMessage
            id='premium.checkout.card_cvc'
            defaultMessage='Security Code'
          />
        )} />

        <div className={styles.inputContainer}>
          <input
            {...input}
            size='4'
            id={name}
            type={type}
            disabled={disabled}
            placeholder={placeholder}
            className={classnames(styles.input, { [styles.error]: showError })}
          />

          {this.props.mode === 'create' ?
            <button
              onClick={this.handleToggleCvc}
              className={styles.tipButton}
              type='button'
            >
              <FormattedMessage
                id='premium.checkout.cvc_tooltip_symbol'
                defaultMessage='?'
              />
            </button>
          : null}

        </div>

        <FieldError
          errorMessage={error}
          showError={showError}
          errorComponent={(
            <FormattedMessage
              id='premium.checkout.invalid_cvc'
              defaultMessage='Invalid security code'
            />
          )}
        />

      </label>
    )
  }

}

CVCField.propTypes = fieldProps

export const renderField = (field) => (
  <CVCField {...field} />
)

export const FieldWrapper = (props) => (
  <Field {...props} component={renderField} />
)

FieldWrapper.propTypes = {
  name: PropTypes.string.isRequired,
  error: PropTypes.node,
  label: PropTypes.node,
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
}

export default FieldWrapper



// WEBPACK FOOTER //
// ./src/components/premium/CCForm/CVCField.jsx